import React from 'react';
import classNames from 'classnames';
import throttle from 'lodash.throttle';
import { configureRange } from './SliderUtils';
import PipList from './PipList';
class Slider extends React.PureComponent {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            this.handleChange = throttle(this.handleChange, 200);
            window.addEventListener('touchmove', this.handleTouchMove);
            window.addEventListener('touchend', this.handleMouseUp);
            window.addEventListener('mousemove', this.handleMouseMove);
            window.addEventListener('mouseup', this.handleMouseUp);
        };
        this.componentWillUnmount = () => {
            window.removeEventListener('touchmove', this.handleTouchMove);
            window.removeEventListener('touchend', this.handleMouseUp);
            window.removeEventListener('mousemove', this.handleMouseMove);
            window.removeEventListener('mouseup', this.handleMouseUp);
        };
        this.setInitialState = (props) => {
            this.setState(this.getInitialState(props));
        };
        this.getInitialState = (props) => {
            const { range, value } = props;
            const configuredRange = configureRange(range);
            const ensuredValue = configuredRange.ensureValue(value || 0);
            const currentStep = configuredRange.getStepForValue(ensuredValue);
            const pressed = false;
            return {
                value: ensuredValue,
                range: configuredRange,
                currentStep,
                pressed,
            };
        };
        this.stepUp = (amount) => {
            const { range, currentStep } = this.state;
            const nextStep = currentStep + amount;
            if (nextStep <= range.maxStep) {
                const nextValue = range.getValueForStep(nextStep);
                this.setState({
                    currentStep: nextStep,
                    value: nextValue,
                });
            }
        };
        this.stepDown = (amount) => {
            const { range, currentStep } = this.state;
            const nextStep = currentStep - amount;
            if (nextStep >= range.minStep) {
                const nextValue = range.getValueForStep(nextStep);
                this.setState({
                    currentStep: nextStep,
                    value: nextValue,
                });
            }
        };
        this.handleChange = () => {
            const { value } = this.state;
            const { onChange } = this.props;
            typeof onChange === 'function' && onChange(value);
        };
        this.handleChangeComplete = () => {
            const { value } = this.state;
            const { onChangeComplete } = this.props;
            typeof onChangeComplete === 'function' && onChangeComplete(value);
        };
        this.handleMouseUp = () => {
            const { pressed } = this.state;
            if (pressed) {
                this.setState({
                    pressed: false,
                });
                this.handleChangeComplete();
            }
        };
        this.handleMouseMove = (event) => {
            const { pressed } = this.state;
            if (pressed) {
                this.handleMove(event);
            }
        };
        this.handleMouseDown = (event) => {
            event.preventDefault();
            this.handlePress();
            this.handleMove(event);
        };
        this.handleTouchMove = (event) => {
            if (this.state.pressed) {
                event.preventDefault();
                this.handleMouseMove(event.touches[0]);
            }
        };
        this.handleTouchStart = (event) => {
            this.handlePress();
            this.handleMove(event.touches[0]);
        };
        this.handlePress = () => {
            if (this.slider) {
                this.sliderRect = this.slider.getBoundingClientRect();
            }
            this.setState({
                pressed: true,
            });
        };
        this.handleMove = (event) => {
            const { clientX } = event;
            const { disabled } = this.props;
            const { range } = this.state;
            const { width, left, right } = this.sliderRect;
            if (!clientX || disabled) {
                return;
            }
            let position;
            if (clientX < left) {
                position = 0;
            }
            else if (clientX > right) {
                position = right - left;
            }
            else {
                position = clientX - left;
            }
            const currentPercentage = Math.round((position / width) * 100);
            const currentStep = range.getStepForPercentagePosition(currentPercentage);
            const value = range.getValueForStep(currentStep);
            if (value !== this.state.value || currentStep !== this.state.currentStep) {
                this.setState({
                    value,
                    currentStep,
                }, this.handleChange);
            }
        };
        this.state = this.getInitialState(props);
    }
    render() {
        const { id, name, disabled, children, className, pips } = this.props;
        const { value, range, currentStep } = this.state;
        const offset = range.getLeftFromCurrentStep(currentStep);
        const offsetStyle = {
            left: `${offset}%`,
        };
        const filledStyle = {
            width: `${offset}%`,
        };
        return (<div className={classNames('StepRangeSlider', className)} onMouseDown={this.handleMouseDown} onTouchStart={this.handleTouchStart} ref={(node) => (this.slider = node)}>
                <div>{pips && <PipList rangeValuesSteps={range.getRangeSteps()} offset={offset}/>}</div>
                <div className="StepRangeSlider__track StepRangeSlider__track--filled" style={filledStyle}/>
                <div className="StepRangeSlider__track"/>
                <div className="StepRangeSlider__handle" onTouchStart={this.handleTouchStart} onMouseDown={this.handleMouseDown} style={offsetStyle}>
                    <div className="StepRangeSlider__thumb" aria-valuemin={range.minValue} aria-valuemax={range.maxValue} aria-valuenow={value} role="slider"/>
                    {typeof children === 'function' ? children(value) : children}
                </div>
                <input type="hidden" id={id} name={name} disabled={disabled}/>
            </div>);
    }
}
Slider.defaultProps = {
    value: 0,
    disabled: false,
    range: [
        {
            value: 0,
            step: 1,
        },
        {
            value: 100,
        },
    ],
    pips: true,
};
export default Slider;
